export default class EventBus {
    constructor() {
        this.events = {}
    }

    $on(eventName, fn, once = false) {
        this.events[eventName] = this.events[eventName] || []
        this.events[eventName].push({ fn, once })
    }

    $once(eventName, fn) {
        this.$on(eventName, fn, true)
    }

    $off(eventName, fn) {
        if (this.events[eventName]) {
            for (let i = 0; i < this.events[eventName].length; i++) {
                if (this.events[eventName][i].fn === fn) {
                    this.events[eventName].splice(i, 1)
                    break
                }
            }
        }
    }

    $emit(eventName, data) {
        if (this.events[eventName]) {
            this.events[eventName].forEach((listener) => {
                listener.fn(data)

                if (listener.once) {
                    this.$off(eventName, listener.fn)
                }
            })
        }
    }
}
